var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-pagination",
    {
      key: _vm.pagerKey,
      staticClass: "c-pagination",
      attrs: {
        pills: "",
        align: "center",
        value: _vm.value,
        "total-rows": _vm.totalRows,
        "per-page": _vm.perPage,
        disabled: _vm.disabled,
      },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
        change: function ($event) {
          return _vm.$emit("change", $event)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "first-text",
          fn: function () {
            return [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c("path", { attrs: { d: "m17 18-6-6 6-6" } }),
                  _c("path", { attrs: { d: "m11 18-6-6 6-6" } }),
                ]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "prev-text",
          fn: function () {
            return [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                  },
                },
                [_c("path", { attrs: { d: "m15 18-6-6 6-6" } })]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "next-text",
          fn: function () {
            return [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                  },
                },
                [_c("path", { attrs: { d: "m9 18 6-6-6-6" } })]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "page",
          fn: function ({ content }) {
            return [
              _c("span", { staticClass: "c-pagination__digit" }, [
                _vm._v(_vm._s(content)),
              ]),
            ]
          },
        },
        {
          key: "last-text",
          fn: function () {
            return [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c("path", { attrs: { d: "m7 18 6-6-6-6" } }),
                  _c("path", { attrs: { d: "m13 18 6-6-6-6" } }),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }